import React from 'react';
import PropTypes from 'prop-types';

import BlockList from '~/components/BlockList';

const Block = ({ blocks }) => {
    return <BlockList {...{ blocks }} />;
};

Block.propTypes = {
    blocks: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired
        })
    ).isRequired
};

export default Block;
